module.exports = __webpack_public_path__ + "media/application/images/svgs/at-sign-04cab8c8a362dcf45a123718fcea3ec0.svg";